export const featureFlagSlugs = {
  transportMagicLinkLogin: 'transport_magic_link_login',
  transportLbv2UiRefresh: 'transport_lb_v2_ui_refresh',
};
